<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>操作日志</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchChooseCard" >
                <span class="label-span">
                    <label class="label">操作人</label> 
                    <el-input v-model.trim="query.loginName" placeholder="操作人" class="handle-input mr15"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">操作人号码</label> 
                    <el-input v-model.trim="query.phone" placeholder="操作人号码" class="handle-input mr15"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label">菜单名称</label> 
                    <el-input v-model.trim="query.fb1" placeholder="菜单名称" class="handle-input mr15"></el-input> 
                </span> 
                <span  class="label-span">
                    <label class="label">操作类型</label> 
                    <el-select v-model="query.oper"  placeholder="操作类型" clearable class="handle-select mr15">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="查询列表"  /> 
                        <el-option value="2" label="添加数据"  /> 
                        <el-option value="3" label="获取数据"  /> 
                        <el-option value="4" label="修改数据"  /> 
                        <el-option value="5" label="状态变更"  /> 
                        <el-option value="9" label="删除数据"  /> 
                        <el-option value="0" label="清除数据"  />   
                    </el-select>
                </span>
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" style="margin-right:25px;"  @click="refreshSearch">重置</el-button>
               <!-- <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >删除日志</el-button> 
               -->
               
            </el-card>
            <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="loginName" width="110" align="left" label="操作人"> </el-table-column>     
                <el-table-column prop="phone" width="110" align="left" label="操作人号码"> </el-table-column>      
                <el-table-column prop="uri" width="210" align="left" label="操作url">
                    <template slot-scope="scope">   
                        <el-link style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.uri}}</el-link>
                        
                    </template> 
                </el-table-column>    
                <el-table-column prop="fb1" width="120" align="left" label="所属菜单"></el-table-column>      
                <el-table-column prop="oper" width="90" align="left" label="操作类型">
                    <template slot-scope="scope">  
                        <el-tag  :type="scope.row.oper==9?'danger':scope.row.oper==0?'danger':scope.row.oper==5?'warning':scope.row.oper==4?'warning':scope.row.oper==2?'primary':'info'">
                            {{scope.row.oper==1?'查询列表':scope.row.oper==2?'添加数据':scope.row.oper==3?'获取数据':scope.row.oper==4?'修改数据':scope.row.oper==5?'状态变更':scope.row.oper==9?'删除数据':scope.row.oper==0?'清除数据':'其它'}} 
                        </el-tag>   
                    </template> 
                </el-table-column>  
                <el-table-column prop="descript" width="110" align="left" label="操作描述">
                </el-table-column>     
                <el-table-column prop="paramData" min-width="130" align="left" label="传入数据">
                    <template slot-scope="scope">  
                        <p v-if="scope.row.paramData!=null && scope.row.paramData!=''">
                         <el-popover placement="left-start" title="详细信息"  width="500" trigger="hover" :content="scope.row.paramData">
                            <span style="background:none;color:blue;font-size:12px;white-space: nowrap; text-overflow: ellipsis;" slot="reference" >{{scope.row.paramData}}</span >
                        </el-popover>
                        </p>
                    </template> 
                </el-table-column>      
                 <el-table-column prop="paramData" min-width="180" align="left" label="异常信息">
                    <template slot-scope="scope">  
                        <p v-if="scope.row.info!=null && scope.row.info!=''">
                         <el-popover placement="left-start" title="详细信息"  width="500" trigger="hover" :content="scope.row.info">
                            <span style="background:none;color:red;font-size:12px;white-space: nowrap; text-overflow: ellipsis;" slot="reference" >{{scope.row.info}}</span >
                        </el-popover>
                        </p>
                    </template> 
                </el-table-column>      
                <el-table-column prop="ip" width="120" align="left" label="操作IP"> </el-table-column>      
                <el-table-column prop="createTime" width="165" align="center"  label="操作时间"> </el-table-column>    
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增分类" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="120px">
                <el-form-item label="产品分类名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="产品分类描述">
                    <el-input v-model.trim="form1.descript"  placeholder="不超过20个字" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑分类" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form3" :model="form3" label-width="120px">
                <el-form-item label="产品分类名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="产品分类描述">
                    <el-input v-model.trim="form2.descript"  placeholder="不超过20个字" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../../api/logError';
export default {

    data() {
        return {  
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false,  
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                ctype:'2',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'phone');  
            this.$set(this.query, 'loginName');    
            this.$set(this.query, 'fb1');    
            this.$set(this.query, 'oper');    
            this.getData();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0); 
        }, 

        //查询
        getData(){ 
            this.query.stationId = this.stationId;  
            this.query.mid = this.mid;
            this.query.secret = this.secret; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        
        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if( !this.form1.name ){
                this.$message.error("请填写分类名称");
                return;
            }  
              this.addVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){ 
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                      this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('该渠道所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该渠道商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
